import React from 'react';
import { SparklesIcon, HeartIcon } from 'lucide-react';
const Hero = () => {
  return <section className="w-full py-16 md:py-24 bg-gradient-to-b from-[#faf7f2] to-[#f6efe8]" data-id="element-155">
      <div className="container mx-auto px-4" data-id="element-156">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-157">
          <div className="flex-1 space-y-6" data-id="element-158">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f8e9e6] text-[#b76e79] text-sm font-medium" data-id="element-159">
              <SparklesIcon size={16} data-id="element-160" />
              <span data-id="element-161">Guía de belleza exclusiva</span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-[#3a3a3a] leading-tight" data-id="element-162">
              La Guía de Belleza que Te Hará Sentir Fabulosa... sin Gastar una
              Fortuna
            </h1>
            <p className="text-lg text-[#5a5a5a]" data-id="element-163">
              Todo lo que necesitas saber para cuidarte, brillar y verte
              increíble desde casa con productos accesibles y técnicas diseñadas
              especialmente para mujeres latinas.
            </p>
            <div className="flex items-center gap-3 pt-4" data-id="element-164">
              <HeartIcon size={16} className="text-[#b76e79]" data-id="element-165" />
              <p className="text-sm text-[#5a5a5a]" data-id="element-166">
                Acceso inmediato • Descarga digital • Garantía de satisfacción
              </p>
            </div>
          </div>
          <div className="flex-1 flex justify-center" data-id="element-167">
            <div className="relative w-full max-w-md" data-id="element-168">
              <div className="bg-white p-4 rounded-lg shadow-2xl" data-id="element-169">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5fWJZ44Q1sza1W1ioT8W78/Guia_de_Belleza_en_Casa.png" alt="Guía de Belleza Latina" className="w-full h-auto object-contain" data-id="element-170" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-3 rounded-lg shadow-lg" data-id="element-171">
                <p className="text-[#b76e79] font-medium" data-id="element-172">4 guías en 1</p>
                <p className="text-xs text-[#5a5a5a]" data-id="element-173">Todo lo que necesitas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;